/**
 * Treeable is the parent class/interface for all dotCMS Objects that can live under a Host/Folder
 */
var Treeable = (function () {
    function Treeable() {
    }
    return Treeable;
}());
export { Treeable };
//# sourceMappingURL=treeable.model.js.map